<style scoped></style>
<template>
  <v-dialog width="450" v-model="dialog.flag">
    <v-card>
      <v-card-title
        class="text-h6 primary_2 white--text d-flex justify-space-between align-center"
      >
        <p>Assign Agent</p>
        <p>
          <v-icon large color="white" @click="dialog.flag = false">
            mdi-close
          </v-icon>
        </p>
      </v-card-title>

      <!-- <v-card-text v-if="skeletonLoader">
        <v-skeleton-loader
          class="elevation-0 pt-8 pb-0"
          v-bind="attrs"
          type="list-item-avatar, list-item-avatar, list-item-avatar, list-item-avatar, actions"
        ></v-skeleton-loader>
      </v-card-text> -->

      <!-- <v-card-text v-else class="pb-0"> -->
      <v-card-text class="pb-0">
        <v-container class="px-0 pb-0" fluid>
          <v-combobox
            v-model="dialog.agent"
            :items="agent_list"
            :loading="agent_loading"
            :search-input.sync="agent_search"
            clearable
            dense
            filled
            hide-details
            item-text="name"
            item-value="id"
            label="Select agent"
            outlined
            placeholder="Select agent"
            single-line
            @focus="getAgentList()"
            @keyup="onAgentSearch()"
          >
            <!-- @change="getCustomerList" -->
            <template v-slot:append-item>
              <div v-intersect="endIntersect"></div>
            </template>
          </v-combobox>
        </v-container>
        <div class="d-flex justify-end">
          <v-btn
            class="white--text mt-0 mb-5 mt-3 mr-2 secondary_2 px-6 rounded-pill"
            @click="assignAgent()"
            :loading="btn_loader"
            :disabled="btn_loader"
          >
            <p>Assign</p>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog"],
  data() {
    return {
      skeletonLoader: true,
      agent_list: [],
      agent_loading: false,
      agent_page: 1,
      // Read from the response so the scroll sentinel knows when to stop.
      agent_total_pages: 1,
      agent_search: "",
      btn_loader: false,
    };
  },
  mounted() {
    this.getAgentList();
  },
  methods: {
    endIntersect(entries, observer, isIntersecting) {
      if (!isIntersecting) return;
      // Guarded for the same reasons as the list screens: agent_loading stops a
      // second request while one is in flight (the menu can intersect several
      // times before the first lands), and agent_total_pages stops us asking
      // for a page past the end every time the user reaches the bottom.
      if (this.agent_loading) return;
      if (this.agent_page >= this.agent_total_pages) return;
      this.agent_page++;
      this.getAgentList(true);
    },
    /**
     * Debounced lookup: this was bound straight to @keyup, firing one
     * request per keystroke. 350 ms matches the interval used by FilterBar
     * and the other list screens.
     */
    onAgentSearch() {
      clearTimeout(this._agentLookupTimer);
      this._agentLookupTimer = setTimeout(() => this.getAgentList(), 350);
    },
    getAgentList(append_agent = false) {
      const self = this;
      // A fresh open or a new search term starts again at page 1.
      if (!append_agent) {
        self.agent_page = 1;
      }
      self.agent_loading = true;
      let params = {
        search_query: this.agent_search,
        page_number: this.agent_page,
      };
      const successHandler = (response) => {
        const result = (response.data && response.data.result) || {};
        const rows = result.user_data || [];
        self.agent_total_pages = result.total_page_count || 1;
        // This used to REPLACE on every scroll while endIntersect walked the
        // page number forward -- so scrolling fetched page 2, 3, 4... and the
        // visible list stayed ten rows and flickered as each one landed.
        if (append_agent) {
          self.agent_list = self.agent_list.concat(rows);
        } else {
          self.agent_list = rows;
        }
      };
      const finallyHandler = () => {
        self.agent_loading = false;
      };

      self.request_GET(
        self,
        self.$urls.TEAM_LIST,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },

    assignAgent() {
      if (this.dialog.agent) {
        const self = this;

        self.btn_loader = true;
        var form = new FormData();
        form.append("loan_id", this.dialog.loan_id);
        form.append("agent_id", this.dialog.agent.id);

        const successHandler = (response) => {
          //   console.log(response);
          // if (response.data.success) {
          self.dialog.flag = false;
          self.$emit("update", {
            loan_id: this.dialog.loan_id,
            agent_assigned: this.dialog.agent.name,
          });
          self.btn_loader = false;
          // }
        };
        const finallyHandler = () => {
          self.btn_loader = false;
        };
        const failureHandler = () => {
          self.btn_loader = false;
        };
        self.POST_request(
          self,
          self.$urls.ASSIGN_AGENT,
          form,
          successHandler,
          null,
          null,
          failureHandler,
          finallyHandler
        );
      } else {
        this.showSnakeBar("error", "Select Agent before assigning");
      }
    },
  },
};
</script>
